import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { TomosAccordion } from './components/TomosAccordion';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Purchase } from './components/Purchase';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-trek-black text-trek-beige font-body selection:bg-trek-orange selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <TomosAccordion data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Countdown data-id="element-8" />
        <Purchase data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}